import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestClientService } from '../services/restclient.service';
import { LoginService } from '../services/login.service';
import { SessaoService } from '../services/sessao.service';
import { AbstractComponent } from '../util/abstract.component';
import { Recaptcha } from '../modelo/captcha';
import { MensagemService } from '../services/mensagem.service';
import { ConfiguracaoVisualService } from '../services/configuracaoVisual.service';
import { MatDialog } from '@angular/material';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ConfiguracaoVisual } from '../modelo/configuracaoVisual';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Config } from '../services/config';

declare var $: any;

@Component({
  selector: 'app-login-parceiro',
  templateUrl: './login-parceiro.component.html',
  styleUrls: ['./login-parceiro.component.css', '../login/login.component.css' ],
  providers: [LoginService, ConfiguracaoVisualService, MensagemService, RestClientService]
})
export class LoginParceiroComponent extends AbstractComponent implements OnInit {

  public isLoaded = false;

  /**
   * Construtor padrão
   */
  constructor(
    private route: ActivatedRoute,
    private sessaoService: SessaoService,
    private loginService: LoginService,
    private mensagemService: MensagemService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    public dialog: MatDialog,
    private configuracaoVisualService: ConfiguracaoVisualService) {
      super(sessaoService);
      sessionStorage.removeItem("TEMPO_SESSAO");
    }

  /**
   * Método chamado na inicialização do componente
   */
  ngOnInit() {
    var url = "";

    if (this.route.snapshot.routeConfig) {
      url = this.route.snapshot.routeConfig.path;
    }

    var id_parceiro = 1;

    if (url === 'login-parceiro-ford') {
      id_parceiro = 2;
    } else if (url === 'login-parceiro-jeep') {
      id_parceiro = 3;
    }

    this.selecionarParceiro(id_parceiro);

    // Resolucao
    var WindowsSize=function() {
      // Toggle menu abrir conforme a resolucao
      var h=$(window).height(),
          w=$(window).width();

      // Conteudo altura
      $(".login").css('height', h);
      $(".footer").css('width', w);
    };
    $(document).ready(WindowsSize);
    $(window).resize(WindowsSize);

    // Condição para exibir modal de primeiro acesso e campanha
    sessionStorage.setItem("modalPrimeiroAcessoCampanha", "true");
  }

  primeiroAcesso() {
    this.obterRecaptcha('/redefinirSenha');
  }

  avancarLogin() {
    if (this.sessaoService.sessao.configuracaoVisual.parceiro.cdParceiro === 1) {
      this.obterRecaptcha('/login');
    } else if (this.sessaoService.sessao.configuracaoVisual.parceiro.cdParceiro === 2) {
      this.obterRecaptcha('/login-ford');
    } else if (this.sessaoService.sessao.configuracaoVisual.parceiro.cdParceiro === 3) {
      this.obterRecaptcha('/login-jeep');
    }
  }

  /**
  * Método para seleção do parceiro
  */
  selecionarParceiro = (id_parceiro: number): void => {
    this.configuracaoVisualService.recuperarConfiguracaoParceiro(id_parceiro).subscribe(
      (result: ConfiguracaoVisual) => {
        if (result.cdMsgemRetorno === '0' || result.cdMsgemRetorno === '2') {
          this.sessaoService.sessao.configuracaoVisual = result;
          this.sessaoService.sessao.cor = "rgb(" + result.nuCorR + ", " + result.nuCorG + ", " + result.nuCorB + ")";
          sessionStorage.setItem("sessaoBF", JSON.stringify(this.sessaoService.sessao));
          this.isLoaded = true;
        } else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      () => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Obtém o key para exibir o recaptcha
   * */
  obterRecaptcha(path: string) {
    this.loginService.obterReCaptcha().subscribe(
      (result: Recaptcha) => {
        if (result && result.nmRecaptcha) {
          this.sessaoService.sessao.keyRecaptcha = result.nmRecaptcha;
          this.router.navigate([path, { cdPagina: 1 }]);
        } else {
          this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
        }
      },
      () => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
   }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/login-parceiro/login-parceiro.component.ts